module.exports = __webpack_public_path__ + "media/images/gallery/en_on-9fdfcd6d2e3a7ad96e2d4d1ee7f7f91f.gif";